import { MutationTree } from 'vuex';
import { LandingState } from './LandingTypes';

export const mutations: MutationTree<LandingState> = {
  setSavedCampaign: (state: LandingState, payload?: any) => {
    state.savedCampaign = payload;
  },
};
